"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollYourOwnOptions = void 0;
/** RollYourOwnOptions.tsx
 *
 * Game Options for RollYourOwn.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.RollYourOwnOptions = {
    versions: [
        {
            title: "7 Cards",
            description: "",
            value: CardVersionSetting_1.CardVersionSetting.SEVEN_CARD,
            default: true,
            flavor: 7,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [defaultOptions_1.winnerHighOnlyDefault, defaultOptions_1.winnerLowOnly, defaultOptions_1.winnerHighLowSplit],
    options: [Object.assign(Object.assign({}, defaultOptions_1.optionRollYourOwnAlwaysDefault), { description: "None" })],
    wildcards: [
        defaultOptions_1.wildcardNoneDefault,
        defaultOptions_1.wildcardLowHoleWithBuy,
        defaultOptions_1.wildcardDeuces,
        defaultOptions_1.wildcardOneEyedJacks,
    ],
};
//# sourceMappingURL=RollYourOwnOptions.js.map